export class TronRpcError extends Error {
    constructor(message, code, data) {
        super(message);
        this.code = code;
        this.data = data;
        this.name = 'TronRpcError';
    }
}
export class TronRpcClient {
    constructor(baseUrl, apiKey) {
        this.baseUrl = baseUrl;
        this.apiKey = apiKey;
    }
    headers() {
        const h = { 'Content-Type': 'application/json' };
        if (this.apiKey)
            h['TRON-PRO-API-KEY'] = this.apiKey;
        return h;
    }
    async post(path, body) {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'POST',
            headers: this.headers(),
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new TronRpcError(`TronGrid HTTP error: ${response.status} ${response.statusText}`);
        }
        return response.json();
    }
    /**
     * Read-only contract call via triggerconstantcontract.
     * Returns the first element of constant_result (hex-encoded return data).
     */
    async triggerConstantContract(contractAddress, functionSelector, parameter, ownerAddress) {
        const result = await this.post('/wallet/triggerconstantcontract', {
            contract_address: contractAddress,
            function_selector: functionSelector,
            parameter,
            owner_address: ownerAddress,
            visible: false,
        });
        if (!result.result?.result) {
            const msg = result.result?.message
                ? Buffer.from(result.result.message, 'hex').toString('utf8')
                : 'triggerconstantcontract failed';
            throw new TronRpcError(msg, result.result?.code, result);
        }
        if (!result.constant_result?.length) {
            throw new TronRpcError('No constant_result returned');
        }
        return result.constant_result[0];
    }
    /**
     * Build an unsigned transaction for a write operation.
     * Returns the unsigned transaction object for signing.
     */
    async triggerSmartContract(contractAddress, functionSelector, parameter, ownerAddress, callValue, feeLimit) {
        const result = await this.post('/wallet/triggersmartcontract', {
            contract_address: contractAddress,
            function_selector: functionSelector,
            parameter,
            owner_address: ownerAddress,
            call_value: callValue ?? 0,
            fee_limit: feeLimit,
            visible: false,
        });
        if (!result.result?.result) {
            const msg = result.result?.message
                ? Buffer.from(result.result.message, 'hex').toString('utf8')
                : 'triggersmartcontract failed';
            throw new TronRpcError(msg, result.result?.code, result);
        }
        return result.transaction;
    }
    /** Fetch transaction by ID */
    async getTransactionById(txId) {
        const result = await this.post('/wallet/gettransactionbyid', { value: txId });
        if (!result || !('txID' in result))
            return null;
        return result;
    }
    /** Fetch transaction info (receipt, logs) by ID */
    async getTransactionInfoById(txId) {
        const result = await this.post('/wallet/gettransactioninfobyid', { value: txId });
        if (!result || !('id' in result))
            return null;
        return result;
    }
}
